(function($) {
    $(document).ready(function() {
        $('body').on('click', 'input[type="date"]', function () {
            this.showPicker()
        })
    })
})(window.jQuery);

